export default {
    en: {
        translation: {
            home: 'Home',
            warehouse: 'Warehouse',
            category: 'Category',
            provider: 'Provider',
            categories: 'Categories',
            selected: 'Selected',
            addNewCategory: 'Add New Category',
            detailCategory: 'Category Detail',
            categoryName: 'Category Name',
            pleaseInputCategoryName: 'Please Input Category Name',
            name: 'Name',
            numberOfProd: 'Products',
            action: 'Action',
            'on/off': 'On/Off',
            cancel: 'Cancel',
            save: 'Save',
            imageCategory: 'Image Category',
            addnewcategorysuccess: 'Category Saved Successfully',
            nameisexist: "Category's Name Is Exist!",
            updatenewcategorysuccess: 'Category Updated Successfully',
            deletesucess: 'Delete Successfully',
            accounts: 'Accounts',
            product: 'Product',
            price: 'Price',
            quantity: 'Quantity',
            sold: 'Sold',
            addNewProduct: 'Add New Product',
            email: 'Email',
            role: 'Role',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            'Active/Inactive': 'Active/Inactive',
            addNewAccount: 'Add New Account',
            createNewAccount: 'Create New Account',
            createAccountSuccessfully: 'Create Account Successfully',
            createNewAccountError: 'Create New Account Error',
            updateAccountInfomationError: 'Update Account Infomation Error',
            updateAccountInfomationsSuccessfully: "Update Account Infomations Successfully",
            updateAccountSecurityError: 'Update Account Security Error',
            updateAccountPasswordSuccessfully: 'Update Account Password Successfully',
            pleaseEnterAnEmail: 'Please Enter An Email',
            pleaseDoNotLeaveItBlank: 'Please Do Not Leave It Blank',
            password: 'Password',
            pleaseEnterPassword: 'Please Enter Password',
            pleaseEnterNewPassword: 'Please Enter New Password',
            validatePass: 'Password must be 6-18 characters, containing numbers, special characters, uppercase and lowercase letters',
            pleaseReEnterPassword: 'Please Re-enter Password',
            pleaseReEnterNewPassword: 'Please Re-enter New Password',
            validate2Pass: 'The two passwords do not match!',
            reEnterPassword: 'Re-enter Password',
            reEnterNewPassword: 'Re-enter New Password',
            accountInfomations: 'Account Infomations',
            pleaseChooseRole: "Please Choose One Role",
            accountPassword: "Account Password",
            newPassword: 'New Password',
            editAnAccount: 'Edit An Account',
            confirmDeleteAccount: 'Confirm Delete Account',
            confirmDelF: 'Account',
            confirmDelL: 'Deleted!',
            sureDelF: 'Are you sure to delete',
            sureDelL: 'account ?',
            warehouseName: 'Warehouse Name',
            address: 'Address',
            city: 'City',
            country: 'Country',
            manager: 'Manager',
            addNewWarehouse: 'Add New Warehouse',
            createNewWarehouse: 'Create New Warehouse',
            createWarehouseSuccessfully: 'Create Warehouse Successfully',
            pleaseEnterWarehouseName: 'Please Enter Warehouse Name',
            pleaseEnterAddress: 'Please Enter Address',
            pleaseEnterCity: 'Please Enter City',
            pleaseEnterCountry: 'Please Enter Country',
            pleaseSelectManager: 'Please Select Manager',
            editWarehouse: 'Edit Warehouse Information',
            updateWarehouseSuccessfully: 'Update Warehouse Successfully',
            confirmDeleteWarehouse: 'Confirm Delete Warehouse',
            sureDelWHF: 'Are you sure to delete warehouse',
            sureDelWHL: '?',
            confirmDelWHF: 'Warehouse',
            confirmDelWHL: 'Deleted!',
            basicInformation: 'Basic Information',
            details: 'Details',
            salesInformation: 'Sales Information',
            prodImages: 'Product Pictures',
            prodName: 'Product Name',
            prodDes: 'Product Description',
            brand: 'Brand',
            size: 'Size',
            material: 'Material',
            volume: 'Volume',
            prodClass: 'Product Classification',
            classGroup: 'Classification Group',
            addProdClass: 'Add Product Classification',
            addClassGroup: 'Add Classification Group',
            listOfProdClass: 'List Of Product Classification',
            applyToAllClass: 'Applies To All Classification',
            deleteConfirm: 'Confirm Delete',
            confirmBodyDeleteProd: 'This will remove the product from your admin list, are you sure?',
            addProdSuccess: 'Product added successfully',
            addProdFail: 'Product added failed',
            addProdImgFail: 'Upload product images failed',
            updateProdSuccess: 'Product updated successfully',
            updateProdFail: 'Product updated failed',
            deleteProdSucces: 'Product deleted successfully',
            deleteProdFail: 'Product deleted failed',
            save: 'Save',
            cancel: 'Cancel',
            update: 'Update',
            provider: 'Provider',
            addNewProvider: 'Add New Provider',
            createNewProvider: 'Create New Provider',
            providerName: 'Provider Name',
            pleaseEnterProviderName: 'Please Enter Provider Name',
            createProviderSuccessfully: 'Create Provider Successfully',
            confirmDelProvF: 'Provider',
            confirmDelProvL: 'Deleted!',
            confirmDeleteProvider: 'Confirm Delete Provider',
            sureDelProvF: 'Are you sure to delete provider',
            sureDelProvL: '?',
            updateProviderSuccessfully: 'Update Provider Successfully',
            editProvider: 'Edit Provider',
            createNewProviderError: 'Create New Provider Error',
            updateProviderError: 'Update Provider Error',
            return: 'Product Returned',
            order: 'Order',
            orderId: 'Order ID',
            status: 'Status',
            amount: 'Amount',
            totalPrice: 'Total Price',
            unitPrice: 'Unit Price',
            changeToShipping: 'Change Status To Shipping',
            changeToPacking: 'Change Status To Packing',
            cancleOrderSuccess: 'Cancel Order(s) Success',
            cancelOrder: 'Cancel Order',
            editFlashSale: 'Edit Flash Sale Infomation',
            createNewFlashSale: 'Create Flash Sale',
            pleaseEnterANumber: 'Please Enter A Number',
            dateSale: 'Expiration Date',
            pleaseEnterExDate: 'Please Enter Expiration Date',
            lowercancel: 'cancel',
            lowernew: 'new',
            lowershipping: 'shipping',
            lowerpacking: 'packing',
            lowerdone: 'done',
            printInvoice: 'Print Invoice',
            printInvoiceDisableTooltip: "Only <b style='text-decoration: underline'>packing</b> and <b style='text-decoration: underline'>shipping</b> orders can print invoices",
            nameProduct: 'Product Name',
            pleaseEnterPriceSale: 'Please Enter Price Sale',
            pleaseEnterAmountSale: 'Please Enter Amount Sale',
            banner: 'Banner',
            nameBanner: 'Banner Name',
            imageBanner: 'Banner Image',
            alwaysShow: 'Always Show',
            expiredBanner: 'Expired Time',
            mainBanner: 'Main Banner',
            addNewBanner: 'Add New Banner',
            subBanner: 'Sub Banner',
            sideBanner: 'Side Banner',
            stillValidStatusBanner: 'Still Valid',
            expiredStatusdBanner: 'Expired',
            createNewBanner: 'Create New Banner',
            pleaseEnterOrderBanner: 'Please Enter Order Of Banner',
            pleaseEnterBannerName: 'Please Enter Banner Name',
            uploadBanner: 'Upload',
            statusBanner: 'Status',
            isMain: 'Is Main Banner',
            isSide: 'Is Side Banner',
            pos1: 'Position 1',
            pos2: 'Position 2',
            bannerOrder: 'Order Of Banner',
            createBannerSuccessfully: 'Create Banner Successfully',
            createNewBannerError: 'Create Banner Error',
            confirmDeleteBanner: 'Confirm Delete Banner',
            sureDelBannerF: 'Are you sure to delete banner',
            sureDelBannerL: '?',
            confirmDelBannerF: 'Banner',
            confirmDelBannerL: 'Deleted!',
            updateBannerSuccessfully: 'Update Banner Successfully',
            editBanner: 'Update Banner',
            updateBannerError: 'Update Banner Error',
            weight: 'Weight',
            about: 'About Shop',
            blog: 'Blog',
            createABlog: 'Create New Blog',
            title: 'Title',
            hide: 'Hide',
            'Insert Image': 'Insert Image',
            Title: 'Title',
            Content: 'Content',
            Save: 'Save',
            'Cover Image': 'Cover Image',
            pleaseEnterCategoryName: 'Please Enter Category Name',
            isSale: 'Is Sale?',
            onSale: 'On Sale!',
            notOnSale: 'Not On Sale!',
            paid: 'Paid',
            unpaid: 'Unpaid',
            paymentStatus: 'Payment Status',
            paymentMethod: 'Payment Method',
            cancelSale: 'End Sale',
        },
    },
    vn: {
        translation: {
            home: 'Trang Chủ',
            warehouse: 'Kho Hàng',
            category: 'Danh Mục',
            provider: 'Nhà Cung Cấp',
            categories: 'Danh Mục',
            selected: 'Đã Chọn',
            addNewCategory: 'Thêm Mới Danh Mục',
            detailCategory: 'Chi Tiết Danh Mục',
            categoryName: 'Tên Danh Mục',
            pleaseInputCategoryName: 'Vui Lòng Nhập Tên Danh Mục',
            name: 'Tên',
            numberOfProd: 'Sản Phẩm',
            action: 'Thao Tác',
            'on/off': 'Bật/Tắt',
            cancel: 'Hủy',
            save: 'Lưu',
            imageCategory: 'Ảnh',
            addnewcategorysuccess: 'Lưu Danh Mục Thành Công',
            nameisexist: 'Tên Danh Mục Đã Tồn Tại',
            updatenewcategorysuccess: 'Cập Nhật Danh Mục Thành Công',
            deletesucess: 'Xóa Thành Công',
            accounts: 'Tài Khoản',
            product: 'Sản Phẩm',
            price: 'Giá',
            quantity: 'Số Lượng',
            sold: 'Doanh Số',
            addNewProduct: 'Thêm Sản Phẩm',
            email: 'Email',
            role: 'Vai Trò',
            createdAt: 'Khởi Tạo Lúc',
            updatedAt: 'Chỉnh Sửa Lúc',
            'Active/Inactive': 'Hoạt Động/Không Hoạt Động',
            addNewAccount: 'Thêm Mới Tài Khoản',
            createNewAccount: 'Thêm Mới Tài Khoản',
            createAccountSuccessfully: 'Thêm Mới Tài Khoản Thành Công',
            createNewAccountError: 'Thêm Mới Tài Khoản Thất Bại',
            updateAccountInfomationError: 'Chỉnh Sửa Thông Tin Tài Khoản Thất Bại',
            updateAccountInfomationsSuccessfully: "Chỉnh Sửa Thông Tin Tài Khoản Thành Công",
            updateAccountSecurityError: 'Chỉnh Sửa Bảo Mật Tài Khoản Thất Bại',
            updateAccountPasswordSuccessfully: 'Chỉnh Sửa Bảo Mật Tài Khoản Thành Công',
            pleaseEnterAnEmail: 'Hãy Nhập Vào Email',
            pleaseDoNotLeaveItBlank: 'Vui Lòng Không Bỏ Trống!',
            password: 'Mật Khẩu',
            pleaseEnterPassword: 'Hãy Nhập Mật Khẩu',
            pleaseEnterNewPassword: 'Hãy Nhập Mật Khẩu Mới',
            validatePass: 'Mật khẩu phải có 6-18 ký tự, bao gồm số, ký tự đặc biệt, chữ hoa và chữ thường',
            pleaseReEnterPassword: 'Vui Lòng Nhập Lại Mật Khẩu',
            pleaseReEnterNewPassword: 'Vui Lòng Nhập Lại Mật Khẩu Mới',
            validate2Pass: 'Mật Khẩu Không Trùng Khớp',
            reEnterPassword: 'Nhập Lại Mật Khẩu',
            reEnterNewPassword: 'Nhập Lại Mật Khẩu Mới',
            accountInfomations: 'Thông Tin Tài Khoản',
            pleaseChooseRole: "Hãy Chọn Một Vai Trò",
            accountPassword: "Bảo Mật Tài Khoản",
            newPassword: 'Mật Khẩu Mới',
            editAnAccount: 'Chỉnh Sửa Tài Khoản',
            confirmDeleteAccount: 'Xác Nhận Xóa Tài Khoản',
            confirmDelF: 'Đã Xóa Tài Khoản',
            confirmDelL: 'Thành Công!',
            sureDelF: 'Xác nhận xóa tài khoản',
            sureDelL: '?',
            warehouseName: 'Tên Kho Hàng',
            address: 'Địa Chỉ',
            city: 'Thành Phố',
            country: 'Quốc Gia',
            manager: 'Người Quản Lý',
            addNewWarehouse: 'Thêm Mới Kho Hàng',
            createNewWarehouse: 'Thêm Mới Kho Hàng',
            createWarehouseSuccessfully: 'Thêm Mới Kho Hàng Thành Công',
            pleaseEnterWarehouseName: 'Hãy Nhập Tên Kho Hàng',
            pleaseEnterAddress: 'Hãy Nhập Địa Chỉ',
            pleaseEnterCity: 'Hãy Nhập Thành Phố',
            pleaseEnterCountry: 'Hãy Nhập Quốc Gia',
            pleaseSelectManager: 'Hãy Chọn Người Quản Lý',
            editWarehouse: 'Chỉnh Sửa Thông Tin Kho Hàng',
            updateWarehouseSuccessfully: 'Chỉnh Sửa Kho Hàng Thành Công!',
            confirmDeleteWarehouse: 'Xác Nhận Xóa Kho Hàng',
            sureDelWHF: 'Xác nhận xóa kho hàng',
            sureDelWHL: '?',
            confirmDelWHF: 'Đã Xóa Kho Hàng',
            confirmDelWHL: 'Thành Công!',
            basicInformation: 'Thông Tin Cơ Bản',
            details: 'Thông Tin Chi Tiết',
            salesInformation: 'Thông Tin Bán Hàng',
            prodImages: 'Hình Ảnh Sản Phẩm',
            prodName: 'Tên Sản Phẩm',
            prodDes: 'Mô Tả Sản Phẩm',
            brand: 'Thương Hiệu',
            size: 'Kích Thước',
            material: 'Chất Liệu',
            volume: 'Thể Tích',
            prodClass: 'Phân Loại Hàng',
            classGroup: 'Nhóm Phân Loại',
            addClassGroup: 'Thêm Nhóm Phân Loại',
            addProdClass: 'Thêm Phân Loại Hàng',
            listOfProdClass: 'Danh Sách Phân Loại Hàng',
            applyToAllClass: 'Áp Dụng Cho Tất Cả Phân Loại',
            deleteConfirm: 'Xác Nhận',
            confirmBodyDeleteProd: 'Việc này sẽ xóa sản phẩm ra khỏi danh sách quản trị của bạn, bạn có chắc chắn?',
            addProdSuccess: 'Thêm sản phẩm thành công',
            addProdFail: 'Thêm sản phẩm thất bại',
            addProdImgFail: 'Tải ảnh lên cho sản phẩm thất bại',
            updateProdSuccess: 'Cập nhật sản phẩm thành công',
            updateProdFail: 'Cập nhât sản phẩm thất bại',
            deleteProdSuccess: 'Xóa sản phẩm thành công',
            deleteProdFail: 'Xóa sản phẩm thất bại',
            save: 'Lưu',
            cancel: 'Hủy',
            update: 'Cập Nhật',
            provider: 'Nhà Cung Cấp',
            addNewProvider: 'Thêm Mới Nhà Cung Cấp',
            createNewProvider: 'Thêm Mới Nhà Cung Cấp',
            providerName: 'Tên Nhà Cung Cấp',
            pleaseEnterProviderName: 'Hãy Nhập Tên Nhà Cung Cấp',
            createProviderSuccessfully: 'Tạo Nhà Cung Cấp Thành Công',
            confirmDelProvF: 'Đã Xóa Nhà Cung Cấp',
            confirmDelProvL: 'Thành Công!',
            confirmDeleteProvider: 'Xác Nhận Xóa Nhà Cung Cấp',
            sureDelProvF: 'Xác nhận xóa nhà cung cấp',
            sureDelProvL: '?',
            updateProviderSuccessfully: 'Chỉnh Sửa Nhà Cung Cấp Thành Công',
            editProvider: 'Chỉnh Sửa Nhà Cung Cấp',
            createNewProviderError: 'Tạo Nhà Cung Cấp Thất Bại',
            updateProviderError: 'Chỉnh Sửa Nhà Cung Cấp Thất Bại',
            return: 'Số Hàng Hoàn',
            order: 'Đơn Hàng',
            orderId: 'Mã Đơn Hàng',
            status: 'Trạng Thái',
            amount: 'Số Lượng',
            totalPrice: 'Tổng Giá',
            unitPrice: 'Đơn Giá',
            changeToShipping: 'Chuyển Trạng Thái Thành Đang Giao',
            cancleOrderSuccess: 'Hủy Đơn Hàng Thành Công',
            cancelOrder: 'Hủy Đơn',
            editFlashSale: 'Chỉnh Sửa Thông Tin Flash Sale',
            createNewFlashSale: 'Tạo Mới Flash Sale',
            pleaseEnterANumber: 'Vui Lòng Nhập Vào Một Số',
            dateSale: 'Ngày Hết Hạn',
            pleaseEnterExDate: 'Vui Lòng Nhập Ngày Hết Hạn',
            changeToPacking: 'Chuyển Trạng Thái Thành Đang Đóng Gói',
            lowercancel: 'hủy',
            lowernew: 'mới',
            lowershipping: 'đang giao',
            lowerpacking: 'đang đóng gói',
            lowerdone: 'hoàn thành',
            printInvoice: 'In hóa đơn',
            printInvoiceDisableTooltip: "Chỉ những đơn hàng <b style='text-decoration: underline'>đang đóng gói</b> hoặc <b style='text-decoration: underline'>đang giao</b> mới có thể in hóa đơn",
            nameProduct: 'Tên Sản Phẩm',
            pleaseEnterPriceSale: 'Vui Lòng Nhập Giá Sale',
            pleaseEnterAmountSale: 'Vui Lòng Nhập Số Lượng Sale',
            banner: 'Banner',
            nameBanner: 'Tên',
            imageBanner: 'Ảnh',
            alwaysShow: 'Luôn Hiển Thị',
            expiredBanner: 'Thời Hạn',
            mainBanner: 'Banner Chính',
            addNewBanner: 'Thêm Mới Banner',
            subBanner: 'Banner Phụ',
            sideBanner: 'Banner Bên',
            stillValidStatusBanner: 'Còn Hạn',
            expiredStatusdBanner: 'Hết Hạn',
            createNewBanner: 'Thêm Mới Banner',
            pleaseEnterOrderBanner: 'Vui Lòng Nhập Thứ Tự Banner',
            pleaseEnterBannerName: 'Vui Lòng Nhập Tên Banner',
            uploadBanner: 'Tải Lên',
            statusBanner: 'Trạng Thái',
            isMain: 'Là Banner Chính?',
            isSide: 'Là Banner Bên?',
            pos1: 'Vị Trí 1',
            pos2: 'Vị Trí 2',
            bannerOrder: 'Thứ Tự Banner',
            createBannerSuccessfully: 'Thêm Mới Banner Thành Công',
            createNewBannerError: 'Thêm Mới Banner Thất Bại',
            confirmDeleteBanner: 'Xác Nhận Xóa Banner',
            sureDelBannerF: 'Xác nhận xóa banner',
            sureDelBannerL: '?',
            confirmDelBannerF: 'Đã Xóa Banner',
            confirmDelBannerL: 'Thành Công!',
            updateBannerSuccessfully: 'Chỉnh Sửa Banner Thành Công',
            editBanner: 'Chỉnh Sửa Banner',
            updateBannerError: 'Chỉnh Sửa Banner Thất Bại',
            weight: 'Cân nặng',
            about: 'Giới Thiệu',
            blog: 'Tin Tức',
            createABlog: 'Tạo Một Bài Viết Mới',
            title: 'Tiêu Đề',
            hide: 'Ẩn',
            'Insert Image': 'Chèn Ảnh',
            Title: 'Tiêu Đề',
            Content: 'Nội Dung',
            Save: 'Lưu',
            'Cover Image': 'Ảnh Bìa',
            pleaseEnterCategoryName: 'Vui Lòng Nhập Tên Danh Mục',
            isSale: 'Có giảm giá?',
            onSale: 'Đang giảm giá!',
            notOnSale: 'Không giảm giá!',
            paid: 'Đã Thanh Toán',
            unpaid: 'Chưa Thanh Toán',
            paymentStatus: 'Tình Trạng Thanh Toán',
            paymentMethod: 'Phương Thức Thanh Toán',
            cancelSale: 'Ngừng Sale',
        },
    },
}